import Vue from 'vue'
import Vuex from 'vuex'

import user from './module/user'
import app from './module/app'
import pictureserv from './module/pictureserv'
import clientaccountserv from './module/clientaccountserv'
import clientserv from './module/clientserv'
import wechatminiprogramaccountserv from './module/wechatminiprogramaccountserv'
import developreportserv from './module/developreportserv'
import renewreportserv from './module/renewreportserv'
import custompoiserv from './module/custompoiserv'
import earnedpremiumplanserv from './module/earnedpremiumplanserv'
import oilchangeplanserv from './module/oilchangeplanserv'
import realtimemonitorsubscribeserv from './module/realtimemonitorsubscribeserv'
import vehiclemaintenanceplanserv from './module/vehiclemaintenanceplanserv'
import vehiclereviewplanserv from './module/vehiclereviewplanserv'
import businessnoteserv from './module/businessnoteserv'
import clientinfoserv from './module/clientinfoserv'
import insurancechannelserv from './module/insurancechannelserv'
import potentialvehicleinfoserv from './module/potentialvehicleinfoserv'
import saleschannelserv from './module/saleschannelserv'
import vehiclebrandserv from './module/vehiclebrandserv'
import vehicledriverinfoserv from './module/vehicledriverinfoserv'
import vehicleinfoserv from './module/vehicleinfoserv'
import vehicleinfogroupserv from './module/vehicleinfogroupserv'
import vehiclemodelserv from './module/vehiclemodelserv'
import vehicleownerinfoserv from './module/vehicleownerinfoserv'
import vehicletypeserv from './module/vehicletypeserv'
import combovehicleinfoserv from './module/combovehicleinfoserv'
import groupserv from './module/groupserv'
import accopenanalysisregulationserv from './module/accopenanalysisregulationserv'
import accopenanalysisresultserv from './module/accopenanalysisresultserv'
import alarmanalysisserv from './module/alarmanalysisserv'
import analysisrangeserv from './module/analysisrangeserv'
import asalarmanalysisresultserv from './module/asalarmanalysisresultserv'
import attentionvehicleanalysisserv from './module/attentionvehicleanalysisserv'
import certencodserv from './module/certencodserv'
import cndtriprecordanalysisresultserv from './module/cndtriprecordanalysisresultserv'
import drivercarddataresultserv from './module/drivercarddataresultserv'
import duplicateterminalnumanalysisresultserv from './module/duplicateterminalnumanalysisresultserv'
import gdczzdsjjrptdataserv from './module/gdczzdsjjrptdataserv'
import gnssreportserv from './module/gnssreportserv'
import harddiskreportserv from './module/harddiskreportserv'
import integralmaterialanalysisresultserv from './module/integralmaterialanalysisresultserv'
import localalarmanalysisregulationserv from './module/localalarmanalysisregulationserv'
import localalarmanalysisresultserv from './module/localalarmanalysisresultserv'
import midnightspeedalarmanalysisresultserv from './module/midnightspeedalarmanalysisresultserv'
import mileagestatisticsanalysisresultserv from './module/mileagestatisticsanalysisresultserv'
import offlineanalysisserv from './module/offlineanalysisserv'
import onlinerateanalysisresultserv from './module/onlinerateanalysisresultserv'
import operationtrendserv from './module/operationtrendserv'
import operationaldataserv from './module/operationaldataserv'
import overspeedanalysisregulationserv from './module/overspeedanalysisregulationserv'
import overspeedanalysisresultserv from './module/overspeedanalysisresultserv'
import samestopanalysisresultserv from './module/samestopanalysisresultserv'
import simflowpoolrecordserv from './module/simflowpoolrecordserv'
import speedlimitareaanalysisregulationserv from './module/speedlimitareaanalysisregulationserv'
import speedlimitareaanalysisresultserv from './module/speedlimitareaanalysisresultserv'
import stopandrunanalysisresultserv from './module/stopandrunanalysisresultserv'
import stopsimcarddataanalysisresultserv from './module/stopsimcarddataanalysisresultserv'
import timeoutparkinganalysisregulationserv from './module/timeoutparkinganalysisregulationserv'
import timeoutparkinganalysisresultserv from './module/timeoutparkinganalysisresultserv'
import tracksintegrityanalysisanalysisresultserv from './module/tracksintegrityanalysisanalysisresultserv'
import tripserv from './module/tripserv'
import unlocatedanalysisserv from './module/unlocatedanalysisserv'
import vehicleofflineanalysisregulationserv from './module/vehicleofflineanalysisregulationserv'
import vehicleofflineanalysisresultserv from './module/vehicleofflineanalysisresultserv'
import vehiclepositioninganomalyanalysisresultserv from './module/vehiclepositioninganomalyanalysisresultserv'
import wirelessdataserv from './module/wirelessdataserv'
import sendcmdserv from './module/sendcmdserv'
import shortmessageserv from './module/shortmessageserv'
import avfileuploadrequesttaskserv from './module/avfileuploadrequesttaskserv'
import jt1078dataserv from './module/jt1078dataserv'
import jt808deviceserv from './module/jt808deviceserv'
import jt808parameterserv from './module/jt808parameterserv'
import jt808parameterdataserv from './module/jt808parameterdataserv'
import netcommandserv from './module/netcommandserv'
import incomeserv from './module/incomeserv'
import outlayserv from './module/outlayserv'
import gddlysjgclientparamserv from './module/gddlysjgclientparamserv'
import gddlysjghazardeventserv from './module/gddlysjghazardeventserv'
import gddlysjglocatehistoryserv from './module/gddlysjglocatehistoryserv'
import gddlysjgtruehazardeventserv from './module/gddlysjgtruehazardeventserv'
import gddlysjgvehicleanalyzereportserv from './module/gddlysjgvehicleanalyzereportserv'
import gddlysjgvehicledataserv from './module/gddlysjgvehicledataserv'
import gddlysjgvehiclequalificationserv from './module/gddlysjgvehiclequalificationserv'
import gpsstandingbookserv from './module/gpsstandingbookserv'
import monitoredareaserv from './module/monitoredareaserv'
import monitoredareagroupserv from './module/monitoredareagroupserv'
import locatehistoryserv from './module/locatehistoryserv'
import positioningdevicefittingserv from './module/positioningdevicefittingserv'
import positioningdevicefittingsserv from './module/positioningdevicefittingsserv'
import positioningdevicefittingstypeserv from './module/positioningdevicefittingstypeserv'
import positioningdeviceinfoserv from './module/positioningdeviceinfoserv'
import positioningdevicetypeserv from './module/positioningdevicetypeserv'
import siminfoserv from './module/siminfoserv'
import accesstokenserv from './module/accesstokenserv'
import authorizeserv from './module/authorizeserv'
import installorderserv from './module/installorderserv'
import jt808servcombineorderserv from './module/jt808servcombineorderserv'
import maintaindevicerecordserv from './module/maintaindevicerecordserv'
import maintainorderserv from './module/maintainorderserv'
import monitoringserviceserv from './module/monitoringserviceserv'
import monitoringserviceorderserv from './module/monitoringserviceorderserv'
import renewalorderserv from './module/renewalorderserv'
import renewalpayorderserv from './module/renewalpayorderserv'
import replacedeviceorderserv from './module/replacedeviceorderserv'
import technicalassistanceserv from './module/technicalassistanceserv'
import backupdbserv from './module/backupdbserv'
import systeminfoserv from './module/systeminfoserv'
import systemlogserv from './module/systemlogserv'
import cpuminutelyserv from './module/cpuminutelyserv'
import memminutelyserv from './module/memminutelyserv'
import annexfileinfoserv from './module/annexfileinfoserv'
import noticeserv from './module/noticeserv'
import noticeinfoserv from './module/noticeinfoserv'
import eyunserv from './module/eyunserv'
import rmfreeserv from './module/rmfreeserv'
import rmfreevehicleserv from './module/rmfreevehicleserv'
import wechatminiprogramcfgserv from './module/wechatminiprogramcfgserv'
import mediaplatformserv from './module/mediaplatformserv'
import webadminerrorlogserv from './module/webadminerrorlogserv'
import usergroupserv from './module/usergroupserv'
import userserv from './module/userserv'
import webtablecolumnsserv from './module/webtablecolumnsserv'
import roleserv from './module/roleserv'
import accountserv from './module/accountserv'
import permissionserv from './module/permissionserv'
import allinpayorderserv from './module/allinpayorderserv'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //
  },
  mutations: {
    //
  },
  actions: {
    //
  },
  modules: {
    user,
    app,
    pictureserv,
    clientaccountserv,
    clientserv,
    wechatminiprogramaccountserv,
    developreportserv,
    renewreportserv,
    custompoiserv,
    earnedpremiumplanserv,
    oilchangeplanserv,
    realtimemonitorsubscribeserv,
    vehiclemaintenanceplanserv,
    vehiclereviewplanserv,
    businessnoteserv,
    clientinfoserv,
    insurancechannelserv,
    potentialvehicleinfoserv,
    saleschannelserv,
    vehiclebrandserv,
    vehicledriverinfoserv,
    vehicleinfoserv,
    vehicleinfogroupserv,
    vehiclemodelserv,
    vehicleownerinfoserv,
    vehicletypeserv,
    combovehicleinfoserv,
    groupserv,
    accopenanalysisregulationserv,
    accopenanalysisresultserv,
    alarmanalysisserv,
    analysisrangeserv,
    asalarmanalysisresultserv,
    attentionvehicleanalysisserv,
    certencodserv,
    cndtriprecordanalysisresultserv,
    drivercarddataresultserv,
    duplicateterminalnumanalysisresultserv,
    gdczzdsjjrptdataserv,
    gnssreportserv,
    harddiskreportserv,
    integralmaterialanalysisresultserv,
    localalarmanalysisregulationserv,
    localalarmanalysisresultserv,
    midnightspeedalarmanalysisresultserv,
    mileagestatisticsanalysisresultserv,
    offlineanalysisserv,
    onlinerateanalysisresultserv,
    operationtrendserv,
    operationaldataserv,
    overspeedanalysisregulationserv,
    overspeedanalysisresultserv,
    samestopanalysisresultserv,
    simflowpoolrecordserv,
    speedlimitareaanalysisregulationserv,
    speedlimitareaanalysisresultserv,
    stopandrunanalysisresultserv,
    stopsimcarddataanalysisresultserv,
    timeoutparkinganalysisregulationserv,
    timeoutparkinganalysisresultserv,
    tracksintegrityanalysisanalysisresultserv,
    tripserv,
    unlocatedanalysisserv,
    vehicleofflineanalysisregulationserv,
    vehicleofflineanalysisresultserv,
    vehiclepositioninganomalyanalysisresultserv,
    wirelessdataserv,
    sendcmdserv,
    shortmessageserv,
    avfileuploadrequesttaskserv,
    jt1078dataserv,
    jt808deviceserv,
    jt808parameterserv,
    jt808parameterdataserv,
    netcommandserv,
    incomeserv,
    outlayserv,
    gddlysjgclientparamserv,
    gddlysjghazardeventserv,
    gddlysjglocatehistoryserv,
    gddlysjgtruehazardeventserv,
    gddlysjgvehicleanalyzereportserv,
    gddlysjgvehicledataserv,
    gddlysjgvehiclequalificationserv,
    gpsstandingbookserv,
    monitoredareaserv,
    monitoredareagroupserv,
    locatehistoryserv,
    positioningdevicefittingserv,
    positioningdevicefittingsserv,
    positioningdevicefittingstypeserv,
    positioningdeviceinfoserv,
    positioningdevicetypeserv,
    siminfoserv,
    accesstokenserv,
    authorizeserv,
    installorderserv,
    jt808servcombineorderserv,
    maintaindevicerecordserv,
    maintainorderserv,
    monitoringserviceserv,
    monitoringserviceorderserv,
    renewalorderserv,
    renewalpayorderserv,
    replacedeviceorderserv,
    technicalassistanceserv,
    backupdbserv,
    systeminfoserv,
    systemlogserv,
    cpuminutelyserv,
    memminutelyserv,
    annexfileinfoserv,
    noticeserv,
    noticeinfoserv,
    eyunserv,
    rmfreeserv,
    rmfreevehicleserv,
    wechatminiprogramcfgserv,
    mediaplatformserv,
    webadminerrorlogserv,
    usergroupserv,
    userserv,
    webtablecolumnsserv,
    roleserv,
    accountserv,
    permissionserv,
    allinpayorderserv
  }
})
